/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { getStudentIdData as getStudentColleges } from '../../../../lib/studentcollegelistview'
import { getDataWithTypeForSelect } from '../../../../lib/parameters'
import style from './colleges.module.css'

export default function Colleges({ slug }) {
	const [collegelist, setCollegeList] = useState([])
	const [parameters, setParameters] = useState([])

	async function GetData() {
		const colleges = await getStudentColleges(slug)
		setCollegeList(colleges)

		const parameterData = await getDataWithTypeForSelect('DESIRED_COLLEGES')
		setParameters(parameterData)
	}

	function getRank(ranks, key) {
		const result = Object.entries(JSON.parse(ranks)).filter((item) => item[0] === key.toString())
		return result[0][1]
	}

	useEffect(() => {
		GetData()
	}, [])

	return (
		<div className="settings-widget">
			<div className="settings-inner-blk p-0">
				<div className="checkout-form personal-address add-course-info p-1">
					<div className="personal-info-head ms-3 d-flex justify-content-between">
						<h4>List Of Desired Colleges</h4>
						<div>
							<Link to={`/instructor/instructor-studentcollegelist/${slug}`} className="btn btn-secondary">
								Add New College
							</Link>
						</div>
					</div>
					<div className="comman-space pb-0">
						<div className="settings-referral-blk course-instruct-blk  table-responsive">
							{/* Instructor Users */}
							<table className="table table-striped mb-0 table-hover">
								<thead>
									<th></th>
									{collegelist ? (
										collegelist.map(function (clist) {
											return (
												<th key={clist.id} className="text-center">
													{clist.collegename}
												</th>
											)
										})
									) : (
										<th></th>
									)}
								</thead>
								<tbody>
									{parameters
										? parameters.map(function (prm) {
												return (
													<tr className={`${style.desiredListRow}`} key={prm.value}>
														<td>{prm.label}</td>

														{collegelist ? (
															collegelist.map(function (c2list) {
																return (
																	<td key={c2list.id} className="text-center">
																		{getRank(c2list.rankvalue, prm.value)}
																	</td>
																)
															})
														) : (
															<td></td>
														)}
													</tr>
												)
										  })
										: ''}
								</tbody>
							</table>
							{/* Instructor List */}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
